export const FILTER_MIN_LENGTH = 2
const FILTER_DELAY_MS = 1000

export default {
  data() {
    return {
      filterText: '',
      filterTimer: null,
      appliedTerm: '',
    }
  },

  computed: {
    searchTerm() {
      const term = this.filterText.trim()
      return term.length >= FILTER_MIN_LENGTH ? term : ''
    },
  },

  watch: {
    filterText() {
      clearTimeout(this.filterTimer)
      if (this.searchTerm === this.appliedTerm) return
      this.filterTimer = setTimeout(() => this.applyFilter(), this.searchTerm ? FILTER_DELAY_MS : 0)
    },
  },

  beforeDestroy() {
    clearTimeout(this.filterTimer)
  },

  methods: {
    applyFilter() {
      clearTimeout(this.filterTimer)
      if (this.searchTerm === this.appliedTerm) return
      this.appliedTerm = this.searchTerm
      this.onFilterApplied()
    },
  },
}
